import React, { useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import block from 'bem-cn'

import logo from 'shared/img/logo.webp'

import { selectLocaleDict } from 'features/locale/selectors'

import { AgentLinkButton } from 'components/AgentLinkButton/AgentLinkButton'
import Search from 'components/Header/Search/Search'
import SetLanguage from 'components/SetLanguage/SetLanguage'
import { WheelButton } from 'components/WheelButton'

import UserBlock from '../UserBlock/UserBlock'

import './TopHeader.scss'

const b = block('top-header')

export const TopHeader = () => {
  const locale = useSelector(selectLocaleDict, shallowEqual).common

  const [isSearchOpen, setIsSearchOpen] = useState<boolean>(false)

  return (
    <div className={b()}>
      <div className={b('left')}>
        <SetLanguage />
        <div className={b('wheel-container')}>
          <WheelButton />
        </div>
      </div>

      <Link to="/" className={b('logo-link', { isOpen: isSearchOpen })} aria-label={locale.home}>
        <img src={logo} alt="logo" className={b('logo')} />
      </Link>

      <div className={b('right')}>
        <Search isOpen={isSearchOpen} setIsOpen={setIsSearchOpen} />
        <AgentLinkButton isStatic />
        <UserBlock />
      </div>
    </div>
  )
}
